var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-wrap"},[_c('div',{staticClass:"progress-now",style:({width: Math.min(100, Math.round(100*_vm.value))+'%'})})])}
var staticRenderFns = []

export { render, staticRenderFns }